/**
 * @generated SignedSource<<2b4b237c788fe1a4b10dc8223793252f>>
 * @relayHash 1c8891d2de520d0c472ec30f899ec6cd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c0a993f8c6b385feb91b377df418219d06b1d885b11740af89e878f7eb7c1b41

import type { ConcreteRequest } from 'relay-runtime';
export type SharedContentQuery$variables = {
  contentId?: string | null | undefined;
  shareToken: string;
};
export type SharedContentQuery$data = {
  readonly singleContent: {
    readonly appearancePublished: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null | undefined;
        readonly key: string | null | undefined;
        readonly value: string | null | undefined;
        readonly version: {
          readonly number: number | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly history: {
      readonly createdDate: string | null | undefined;
      readonly lastUpdated: {
        readonly when: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly id: string | null | undefined;
    readonly properties: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null | undefined;
        readonly key: string | null | undefined;
        readonly value: string | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly referenceId: string | null | undefined;
    readonly space: {
      readonly alias: string | null | undefined;
      readonly id: string | null | undefined;
      readonly key: string | null | undefined;
      readonly name: string | null | undefined;
    } | null | undefined;
    readonly status: string | null | undefined;
    readonly title: string | null | undefined;
    readonly type: string | null | undefined;
    readonly version: {
      readonly friendlyWhen: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type SharedContentQuery = {
  response: SharedContentQuery$data;
  variables: SharedContentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shareToken"
},
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "key"
},
v4 = {
  "kind": "ScalarField",
  "name": "value"
},
v5 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      },
      {
        "kind": "Variable",
        "name": "shareToken",
        "variableName": "shareToken"
      }
    ],
    "concreteType": "Content",
    "kind": "LinkedField",
    "name": "singleContent",
    "plural": false,
    "selections": [
      (v2/*: any*/),
      {
        "kind": "ScalarField",
        "name": "referenceId"
      },
      {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "ScalarField",
            "name": "alias"
          },
          {
            "kind": "ScalarField",
            "name": "name"
          }
        ]
      },
      {
        "kind": "ScalarField",
        "name": "title"
      },
      {
        "kind": "ScalarField",
        "name": "type"
      },
      {
        "kind": "ScalarField",
        "name": "status"
      },
      {
        "concreteType": "History",
        "kind": "LinkedField",
        "name": "history",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "createdDate"
          },
          {
            "concreteType": "Version",
            "kind": "LinkedField",
            "name": "lastUpdated",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "when"
              }
            ]
          }
        ]
      },
      {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "friendlyWhen"
          }
        ]
      },
      {
        "alias": "appearancePublished",
        "args": [
          {
            "kind": "Literal",
            "name": "key",
            "value": "content-appearance-published"
          }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
          {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "number"
                  }
                ]
              }
            ]
          }
        ],
        "storageKey": "properties(key:\"content-appearance-published\")"
      },
      {
        "args": [
          {
            "kind": "Literal",
            "name": "key",
            "value": "editor"
          }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
          {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ]
          }
        ],
        "storageKey": "properties(key:\"editor\")"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "SharedContentQuery",
    "selections": (v5/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "SharedContentQuery",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "1c8891d2de520d0c472ec30f899ec6cd",
    "id": "c0a993f8c6b385feb91b377df418219d06b1d885b11740af89e878f7eb7c1b41",
    "metadata": {},
    "name": "SharedContentQuery",
    "operationKind": "query",
    "text": "query SharedContentQuery($shareToken:String!,$contentId:ID){singleContent(shareToken:$shareToken,id:$contentId){id,referenceId,space{id,key,alias,name},title,type,status,history{createdDate,lastUpdated{when}},version{friendlyWhen},appearancePublished:properties(key:\"content-appearance-published\"){nodes{id,key,value,version{number}}},properties(key:\"editor\"){nodes{id,key,value}}}}"
  }
};
})();

(node as any).hash = "f69752c0192f5e7f1b6881d686b9b509";

export default node;
